import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material';
import { button } from './button';
import { typography } from './typography';
import { checkbox } from './checkbox';
// import type {} from '@mui/lab/themeAugmentation';

export const components: Components = {
  ...button,
  ...typography,
  ...checkbox,
};

export const theme = createTheme({
  components,
});

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    tertiary: true;
    ghost: true;
  }
}
